module.exports = __webpack_public_path__ + "static/media/0110_LE_CIEL_DE_BOIS.40a0c6e0.webp";